import { useSiteAboutStore } from "../siteAboutStore/siteAboutStore";
import { SiteCamerasResult } from "./siteAboutInterfaces";

export const checkForUseMotion = (siteCameras: SiteCamerasResult[]) => {
  const setHideUseMotion = useSiteAboutStore.getState().setHideUseMotion;

  // Check if any camera has a valid value for use_motion (not undefined, null,
  // or empty string), or a per-camera override (the label can be blank while
  // an override is set, and the column carries the override marker).
  const hasUseMotionValue = siteCameras.some(
    (camera) =>
      (camera?.use_motion !== undefined &&
        camera?.use_motion !== null &&
        camera?.use_motion !== "") ||
      typeof camera?.use_motion_override === "boolean"
  );

  // If no cameras have a valid use_motion value, set hideUseMotion to true
  if (!hasUseMotionValue) {
    setHideUseMotion(true);
  } else {
    setHideUseMotion(false);
  }
};
